import { IssueContainersForSamplingComponent } from './../app/components/sidenav/pages/import-incharge/issue-containers-for-sampling/issue-containers-for-sampling.component';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//test https://octatest-api.natsoft.io

export const environment = {
  production: false,

  //Dev2 Environment
  // webUrl: "https://octa2dev-api.natsoft.io/fc",
  // apiUrl: 'https://octa2dev-api.natsoft.io/',
  // hashUrl:'https://octa2dev-api.natsoft.io',

  //UAT Env
  // webUrl: "https://ocatuatp2-api.natsoft.io/fc",
  // apiUrl: 'https://ocatuatp2-api.natsoft.io/',



  //Prod Env
  // webUrl: "https://prodocta-api.natsoft.io/fc",
  // apiUrl: 'https://prodocta-api.natsoft.io/',
  // hashUrl:'https://prodocta-api.natsoft.io',


  // webUrl:"http://192.168.2.53/fc",

  // apiUrl:'http://192.168.2.53/',

  //QA Environmentnot
  // webUrl:'https://qa-octa.natsoft.io/fc',
  // apiUrl:'https://octaqa-api.natsoft.io/',

  // Dev Environment
  // webUrl:"https://dev-octa.natsoft.io/fc",
  // apiUrl:'https://octadev2-api.natsoft.io/',

  //TEST Enviroment
  // webUrl:"https://test-octa.natsoft.io/fc",
  // apiUrl:'https://octatest-api.natsoft.io/',

  //PROD Enviroment
  // webUrl:"https://prod-octa.natsoft.io/fc",
  // apiUrl:'https://octaprod-api.natsoft.io/',


  // apiUrl:'http://localhost:9001/',

  // UAT CLIENT ENV
  webUrl: "https://uat-octa.goafocta.org/fc",
  apiUrl: 'https://uat-octa.goafocta.org/',
  hashUrl: 'https://uat-octa.goafocta.org',

  // PROD CLIENT 
  // webUrl: "https://prod-octa.goafocta.org/fc",
  // apiUrl: 'https://prod-octa.goafocta.org/',
  // hashUrl: 'https://prod-octa.goafocta.org',


  // Authentication Api Method
  createUser: 'api/login/register',
  login: 'api/login/signin',
  loginOTP: 'api/login/otp',
  loginOTPVerify: 'api/users/forgotPasswordOTPVerify',
  forgotpassword: 'api/login/otp',
  validOTP: 'api/login/validateOTP',
  // forgotpassword:'api/users/forgotpassword',
  updatePassword: 'api/login/changepwd',

  //roles
  roleList: 'api/role/checkRoleExists',
  rolesListByOrganisation: 'msi/receiver/apiRequest',


  //Data Entry Operator APi's

  generateUniqueChallanNo: 'msi/receiver/apiRequest',
  getCropYearsList: 'msi/receiver/apiRequest',
  getDivisionsList: 'msi/receiver/apiRequest',
  getChallansList: 'msi/receiver/apiRequest',
  getUploadedChallans: "msi/receiver/apiRequest",
  addContainerManual: "msi/receiver/apiRequest",
  addContainerAutomatic: "msi/receiver/apiRequest",
  fileUpload: "msi/import/docupload",


  //verifier Api's
  getChallanDetailsByChallanId: "msi/receiver/apiRequest",
  updateChallanStatusToSumitted: "msi/receiver/apiRequest",
  updateContainerNET_GROSS_WEIGHT: "msi/receiver/apiRequest",
  getVerifiedPendingList: "msi/receiver/apiRequest",
  updateVerifiedStatus: "msi/receiver/apiRequest",
  GEN_QR_CODEFORVERIFIER: "msi/receiver/verifyQR",


  //Ass Import Incharge

  getValidateList: 'msi/receiver/apiRequest',
  containerWiseLogs: "msi/receiver/apiRequest",
  updateValidateStatus: "msi/receiver/apiRequest",
  updateExistContainer: "msi/receiver/apiRequest",

  //Import Incharge
  getReceiveContainerList: "msi/receiver/apiRequest",
  updateLocationName: "msi/receiver/apiRequest",
  updateReceiveBackStatus: "msi/receiver/apiRequest",
  getSampleAssistantList: "msi/receiver/apiRequest",
  assigningSampleAssitant: "msi/receiver/apiRequest",
  getAllotedList: "msi/receiver/apiRequest",
  sendSamplesToLab: "msi/receiver/apiRequest",


  //Super Admin

  getReceiverCountList: "msi/receiver/apiRequest",
  receivedContainerSelected: "msi/receiver/apiRequest",
  userLogs: 'msi/dash',
  setUserDeactive: 'msi/dash',
  getDivisionUnit: "msi/receiver/apiRequest",
  IPWhitelist: "api/login/restrict_IP",
  downLoadFile: "api/download",



  //Sample Assistant
  getSamplesDetails: "msi/receiver/apiRequest",
  decryptQRCode: "msi/receiver/apiRequest",
  createSampleWithQRCode: "msi/receiver/apiRequest",
  sampleDrawnPush: "msi/receiver/apiRequest",
  sampledPrintLog: "msi/receiver/apiRequest",
  printSample: 'msi/receiver/apiRequest',


  //lab receiver
  getLabReceiverDetails: "msi/receiver/apiRequest",
  decryptQRCodeForLabReceiver: "msi/receiver/apiRequest",
  updateReceiveForTesting: "msi/receiver/apiRequest",
  editTray: 'msi/receiver/apiRequest',
  getTrayList: 'msi/receiver/apiRequest',
  sendToLabAdmin: "msi/receiver/apiRequest",

  //labadmin
  getReceivedForTesting: "msi/receiver/apiRequest",
  labAnalystList: "msi/receiver/apiRequest",
  assignLabAnalyst: "msi/receiver/apiRequest",
  reAssignLabAnalyst: "msi/dash",
  trayIdList: "msi/receiver/apiRequest",
  trayIdWiseDetails: "msi/receiver/apiRequest",
  printResults: "msi/receiver/apiRequest",

  //lab analyst
  updateConsistency: "msi/receiver/apiRequest",
  resultsUpdated: "msi/receiver/apiRequest",

  //lab ace


  //container
  createContainer: 'api/container/createContainer',
  selectContainerList: 'api/container/selectContainerList',
  selectByContainer: 'api/container/selectByContainer',
  selectByContainerNumber: 'api/container/selectByContainerNumber',
  updateContainerStatus: 'api/container/updateContainerStatus',
  updateNoContainers: 'api/container/updateNoContainers',
  updateNetGrossweight: 'api/container/updateNetGrossweight',
  getVerifyStatus: 'api/container/getVerifyStatus',
  checkIpAddress: 'https://ipv4.myexternalip.com/json',

  getContainerDetails: 'api/container/getContainerDetails',

  listDivisionByOrganisationId: 'api/division/listDivisionByOrganisationId',
  listChallanByOrganisationId: 'api/challan/listChallanByOrganisationId',
  updateInCharge: 'api/container/updateInCharge',
  updateContainwise: 'api/container/updateContainwise',
  updateRemarks: 'api/container/verifyRemarks',
  editContainer: 'api/container/editContainer',
  deleteContainer: 'api/container/DeleteContainer',
  ExcelCreateContainer: 'api/container/ExcelCreateContainer',
  getFactoryContainerNo: 'api/container/getFactoryContainerNo',

  //sampling apis
  SAMPLING_GET_CHALLANS: 'ms2/apiRequest',

  getRandomChallans: 'ms2/apiRequest',

  saveSelectedSamplingChallans: 'ms2/saveSelectedSamplingChallans',
  issueContainersForSampling: 'ms2/apiRequest',
  sampleAssistantList: 'ms2/apiRequest',
  viewIssuedForSampling: 'ms2/apiRequest',
  createSample: 'ms2/apiRequest',
  sentToLabs: 'ms2/apiRequest',
  genQRsampleId: 'ms2/genEncry_QR_CODE',
  SAMPLING_UPDATE_RECEIVE_IN_PROGRESS: 'ms2/apiRequest',
  SAMPLING_UPDATE_RECEIVED_TESTING: 'ms2/apiRequest',
  samplesSentList: 'ms2/apiRequest',
  GET_LAB_ANYS_ALLOTED: 'ms2/apiRequest',
  SMPL_TESTING_LIST: "ms2/apiRequest",
  updateReceiveSampleStatus: "ms2/apiRequest",
  updateResultUploaded: 'ms2/update_LABACE',
  labAceUpdateResultUploaded: 'ms2/update_LABACE',

  bulkupdateResultUploaded: 'msi/receiver/bulkUpload',
  listDivisionByOrganisation: 'api/division/listDivisionByOrganisationId',
  DecryptQR: 'ms2/Decrypt_QR_Code',
  deleteTray: 'ms2/apiRequest',
  dashboardSummary: 'ms2/apiRequest',
  changeReceiveBack: 'ms2/apiRequest',

  getTraySequenceNumber: 'ms2/apiRequest',

  bulkupload_update: 'msi/receiver/apiRequest',
  getChallanEnquiryData: 'msi/dash',
  getDaySummeryData: 'msi/dash',
  getCropYearSummuryData: 'msi/dash',


  getUserList: 'ms2/apiRequest',
  masterDataDivisionsList: 'ms2/apiRequest',
  addDivision: "msi/dash",


  getCropYearList: 'ms2/apiRequest',
  labreceiverStatus: 'ms2/apiRequest',
  sentToImportIncharge: "ms2/apiRequest",
  misFilter: 'msi/dash/DY-MIS',
  misReportOne: 'msi/dash/DY-MIS',
  getFile: 'msi/dash/getFile',
  getFactoryContainerList: 'msi/dash/DY-MIS'


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

// 1.TESTING IN PROGRESS LIST
// 2.

